import request from '#/utils/request';
import { parseVer4DetailResponse } from '#/api/adapters/envelope';
import { normalizeBomWire } from '#/api/momMgmt/settings/bom/normalizeBomWire';

export async function fetchBomDetail(id) {
  const { data: raw } = await request.get(`/mom/bom/${id}`);
  const parsed = parseVer4DetailResponse(raw);
  return {
    ...parsed,
    data: normalizeBomWire(parsed.data),
  };
}
